module.exports = __webpack_public_path__ + "9baf5ffbc2f4dd03e3f89543edcf6ba4.jpg";